import { Dispatch, SetStateAction, useMemo } from 'react'
import { useFullscreenModeOnMediaOpen } from '$comp/_app/components/chat/components/footer/components/send-field/react-hooks'
import { ImagePreviewTypes, VideoPreviewTypes } from '../../send-field.type'
import { FilePreview } from './file-preview'
import { ImagePreview } from './image-preview'
import { VideoPreview } from './video-preview'
import { AudioPreview } from './audio-preview'
import { messageTypeByFileType } from '$func/file'

export function UploadPreview({
  file,
  onCancel,
  hasBorder,
  imagePreviewMode,
  videoPreviewMode,
  setImagePreviewMode,
  setVideoPreviewMode,
  setFile,
  setVideoCompressionHeight,
  videoCompressionHeight,
  makeSendFieldFullscreen,
}: {
  file: File
  onCancel: () => void
  hasBorder: boolean
  imagePreviewMode: ImagePreviewTypes
  videoPreviewMode: VideoPreviewTypes
  setImagePreviewMode: Dispatch<SetStateAction<ImagePreviewTypes>>
  setVideoPreviewMode: Dispatch<SetStateAction<VideoPreviewTypes>>
  setFile: (newFile: File) => unknown
  setVideoCompressionHeight: (height: number) => unknown
  videoCompressionHeight?: number
  makeSendFieldFullscreen: () => void
}) {
  const messageType = useMemo(
    () => messageTypeByFileType(file.type),
    [file.type],
  )

  useFullscreenModeOnMediaOpen(messageType, makeSendFieldFullscreen, onCancel)

  return messageType === 'IMAGE' ? (
    <ImagePreview
      file={file}
      onCancel={onCancel}
      imagePreviewMode={imagePreviewMode}
      setImagePreviewMode={setImagePreviewMode}
      setFile={setFile}
    />
  ) : messageType === 'VIDEO' ? (
    <VideoPreview
      file={file}
      onCancel={onCancel}
      videoPreviewMode={videoPreviewMode}
      setVideoPreviewMode={setVideoPreviewMode}
      setVideoCompressionHeight={setVideoCompressionHeight}
      compressionHeight={videoCompressionHeight}
    />
  ) : messageType === 'AUDIO' ? (
    <AudioPreview file={file} onCancel={onCancel} hasBorder={hasBorder} />
  ) : (
    <FilePreview file={file} onCancel={onCancel} hasBorder={hasBorder} />
  )
}
